export const actionItems = [
  { value: '', text: 'Choisir...' },
  { value: 'edit', text: 'Editer' },
  { value: 'move', text: 'Déplacer' },
  { value: 'delete', text: 'Supprimer' },
];
